import { alpha } from '@mui/material/styles';

// Shared look of every sidebar submenu (regular branches and the assistant
// branch): an indented list hanging off a connector line, with compact rows.

export const branchListSx = (theme) => ({
    mr: 2.5,
    pr: 1,
    mt: 0.5,
    borderRight: `1px solid ${alpha(theme.palette.border.main, 0.6)}`,
});

export const childSx = (theme, active) => ({
    borderRadius: '.6rem',
    minHeight: '2.25rem',
    py: 0.25,
    pr: 1,
    pl: 0.5,
    bgcolor: active ? alpha(theme.palette.primary.main, 0.16) : 'transparent',
    '& .MuiListItemText-primary': {
        fontSize: '0.82rem',
        fontWeight: active ? 700 : 'normal',
        color: active ? theme.palette.text.active : theme.palette.text.default,
    },
    '& .MuiListItemIcon-root': { minWidth: 0, ml: 1 },
    // The text box stretches across the row; without this it inherits
    // text-align:left and the label drifts away from its icon.
    '& .MuiListItemText-root': { m: 0, textAlign: 'right' },
    '& .MuiSvgIcon-root': { fontSize: '1.05rem', color: theme.palette.text.default },
    '&:hover': { bgcolor: alpha(theme.palette.primary.main, 0.12) },
});

// Bullet for child rows without an icon. It fills the same slot as a child
// icon, so labels line up across branches and the dot never touches the text.
export const childDotSx = (theme, active) => ({
    width: '1.05rem',
    display: 'flex',
    justifyContent: 'center',
    '&::before': {
        content: '""',
        width: '4px',
        height: '4px',
        borderRadius: '50%',
        backgroundColor: active ? theme.palette.text.active : theme.palette.text.default,
        opacity: active ? 1 : 0.55,
    },
});
